import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import styled from "@emotion/styled";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategoriesList} from "../components/ArticleCategoriesList";
import {AuthorsListAuthorBox} from "../components/authors/AuthorsListAuthorBox";
import {SchemaArticleAuthorDetail} from "../schemas/SchemaArticleAuthorDetail";

export const ArticleAuthorsListView = () => {
    const authors = useSelector((state: IRPStore) => state.article.authors.authors);
    const locationPathname = useLocation().pathname;

    return (
        <article>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} css={[mt(2)]}>
                    <BreadcrumbsItem name="Wiadomości" position="2" url={rpAppLink.article.list()} />
                    <BreadcrumbsItem name="Autorzy" position="3" isLinkingToCurrentLocation />
                </Breadcrumbs>

                <Text variant="headline_1" as="h1" css={[mt(2), mb(2), onDesktop(mb(4))]}>
                    Autorzy
                </Text>

                <Row>
                    {authors.map((author) => (
                        <ColStyled key={author.id} sm={4}>
                            <AuthorsListAuthorBox author={author} />
                            <SchemaArticleAuthorDetail
                                name={author.name}
                                description={author.description}
                                pathname={locationPathname}
                                authorImageUrl={!!author.image ? author.image.a_img_130x130 : ""}
                            />
                        </ColStyled>
                    ))}
                </Row>
                <Row>
                    <Col>
                        <ArticleCategoriesList css={[mt(6), mb(4), onDesktop(mt(8))]} />
                    </Col>
                </Row>
            </Container>
        </article>
    );
};

const ColStyled = styled(Col)`
    @media (min-width: 1200px) {
        max-width: 50%;
    }
`;
import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import styled from "@emotion/styled";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategoriesList} from "../components/ArticleCategoriesList";
import {AuthorsListAuthorBox} from "../components/authors/AuthorsListAuthorBox";
import {SchemaArticleAuthorDetail} from "../schemas/SchemaArticleAuthorDetail";

export const ArticleAuthorsListView = () => {
    const authors = useSelector((state: IRPStore) => state.article.authors.authors);
    const locationPathname = useLocation().pathname;

    return (
        <article>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} css={[mt(2)]}>
                    <BreadcrumbsItem name="Wiadomości" position="2" url={rpAppLink.article.list()} />
                    <BreadcrumbsItem name="Autorzy" position="3" isLinkingToCurrentLocation />
                </Breadcrumbs>

                <Text variant="headline_1" as="h1" css={[mt(2), mb(2), onDesktop(mb(4))]}>
                    Autorzy
                </Text>

                <Row>
                    {authors.map((author) => (
                        <ColStyled key={author.id} sm={4}>
                            <AuthorsListAuthorBox author={author} />
                            <SchemaArticleAuthorDetail
                                name={author.name}
                                description={author.description}
                                pathname={locationPathname}
                                authorImageUrl={!!author.image ? author.image.a_img_130x130 : ""}
                            />
                        </ColStyled>
                    ))}
                </Row>
                <Row>
                    <Col>
                        <ArticleCategoriesList css={[mt(6), mb(4), onDesktop(mt(8))]} />
                    </Col>
                </Row>
            </Container>
        </article>
    );
};

const ColStyled = styled(Col)`
    @media (min-width: 1200px) {
        max-width: 50%;
    }
`;
